import { request } from "@/composables/useFetch";

const prefix = "/v1/admin";
export function list(page, size, keySearch) {
    return request(`${prefix}/departments?page=${page}&size=${size}&keySearch=${keySearch}`);
}

export function create(data) {
    return request(`${prefix}/department`, {method: 'POST', body: data});
}

export function update(id, data) {
    return request(`${prefix}/department/${id}`, {method: 'PUT', body: data});
}

export function deleteDepartment(id) {
    return request(`${prefix}/department/${id}`, {method: 'DELETE'});
}
